import {useSubheader} from "../../../_metronic/layout";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import makeRequest, {makeFormDataRequest} from "../../api/makeRequest";
import Select from "react-select";


export const EditFilePage = ({match}) => {
	const { t } = useTranslation('common');
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('EditFile'));

	const {id} = match.params
	const [loading, setLoading] = useState(false);
	const [okMessage,setOkMessage] = useState('');

	const [name,setName] = useState('')
	const [isPublic,setIsPublic] = useState(true)
	const [roomId,setRoomId] = useState(null)

	const [rooms,setRooms] = useState([])

	useEffect(()=>{
		const getRoomsSimple = async () => {
			try {
				const {data} = await makeRequest('getRoomsSimple', {})
				const rooms = data.rooms
				setRooms(rooms)
			} catch (e) {
				console.log(e)
			}
		}

		getRoomsSimple()
	},[])

	useEffect(()=>{
		const getFile = async () => {
			try {
				const {data} = await makeRequest('getFile', {id})
				const file = data.file
				setName(file.name)
				setIsPublic(file.isPublic)
				setRoomId(file.room.id)
			} catch (e) {
				console.log(e)
			}
		}

		getFile()
	},[])

	const [status,setStatus] = useState("")
	const [errors,setErrors] = useState({})


	const enableLoading = () => {
		setLoading(true);
	};

	const disableLoading = () => {
		setLoading(false);
	};


	let history = useHistory();

	const handleSubmit = (e)=>{
		e.preventDefault()
		if (!name) {
			setErrors(prev=>({
				...prev,
				name:t('EnterName')
			}))
			return
		}
		if (!roomId) {
			setErrors(prev=>({
				...prev,
				room_id:t('ChooseRoom')
			}))
			return
		}

		enableLoading();
		const formData = new FormData()
		formData.append('name',name)
		formData.append('isPublic',isPublic)
		formData.append('room_id',roomId)
		makeFormDataRequest(`panel/import/file/edit/${id}`,formData )
			.then(({data}) => {
			const {success} = data
			if(success) {
				setOkMessage(t('Edited'))
				setTimeout(()=>{
					history.push('/file')
				},1000)
			}else{
				const {error} = data
				setStatus(error)
			}
		}).catch((e) => {
			setStatus(t('Error'))
		}).finally(() => {
			disableLoading();
		})
	}

	const selectedRoomIdObj = rooms.find(q=>q.public_id === roomId) ? rooms.find(q=>q.public_id === roomId).name : roomId
	return (
		<>
			<form
				onSubmit={handleSubmit}
				className="form fv-plugins-bootstrap fv-plugins-framework"
			>
				{status ? (
					<div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div className="alert-text font-weight-bold">{status}</div>
					</div>
				) : null}
				{okMessage ? (
					<div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
						<div className="alert-text font-weight-bold">{okMessage}</div>
					</div>
				) : null}

				<div className="form-group fv-plugins-icon-container">
					<label>{t('FileName')}</label>
					<input
						placeholder={t('Name')}
						type="text"
						defaultValue={name}
						key={name}
						onChange={(e)=>{
							const v = e.target.value
							setName(v)
						}}
						className={`form-control form-control-solid h-auto py-5 px-6`}
						name="name"
					/>
					{errors.name ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{errors.name}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<label>{t('RoomName')}</label>
					<Select
						onChange={(e)=>{
							setRoomId(e.value)
						}}
						name='room_id'
						key={selectedRoomIdObj}
						defaultValue={{value:roomId,label:selectedRoomIdObj}}
						options={rooms.map(room=>({ value: room.public_id, label: room.name}))}
					/>
					{errors.room_id ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{errors.room_id}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<label>{t('Downloadable')}</label>
					<input
						placeholder={t('Downloadable')}
						type="checkbox"
						className={`form-control text-center form-control-solid h-auto py-5 px-6 w-auto mx-10 d-inline-block`}
						name="isPublic"
						key={isPublic}
						defaultChecked={isPublic}
						onChange={()=>{
							setIsPublic(prev=>!prev)
						}}
					/>
				</div>
				<div className="form-group d-flex flex-wrap justify-content-between align-items-center">
					<button
						id="kt_login_signin_submit"
						type="submit"
						disabled={loading}
						className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
					>
						<span>{t('EditFile')}</span>
						{loading && <span className="blockui m-1 ml-3 spinner spinner-white"/>}
					</button>
				</div>
			</form>
		</>
	)
}
